<template>
	<div class="p-contact">
    <div class="banner">
      <!-- <div class="inner">
        <div class="title">善识健康</div>
        <div class="desc">一站式智能营养健康管理云平台</div>
        <a>免费咨询</a>
      </div> -->
    </div>
    <div class="part">
      <img src="/image/contact/address.png"/>
    </div>
	</div>
</template>

<script>
export default {
  data() {
    return {
      links: [
        {
          title: "一站式体重管理解决方案",
          desc: "适用于专业体重管理公司、健身房、美容院等机构",
          img: "/image/contact/41.jpg"
        },
        {
          title: "一站式老年营养解决方案",
          desc:
            "基于中国老年营养餐行业标准，提供包括营养筛查、营养配餐及营养咨询等，为老年服务机构提供专业的营养管理与干预",
          img: "/image/contact/42.jpg"
        },
        {
          title: "社区营养与健康管理解决方案",
          desc:
            "适用于传统保健企业转型健康管理，适用于基层医疗卫生机构服务升级",
          img: "/image/contact/43.jpg"
        }
      ]
    };
  }
};
</script>

<style lang="less">
.p-contact {
  > .banner {
    width: 100%;
    height: 450px;
    display: flex;
    align-items: center;
    background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat;
    background-image: url("/image/contact/banner.png");
    > .inner {
      width: 1010px;
      color: #ffffff;
      margin: 0px auto;
      > .title {
        font-size: 50px;
        margin: 15px 0px;
      }
      > .desc {
        font-size: 24px;
        margin: 15px 0px;
        letter-spacing: 10px;
      }
      > a {
        font-size: 18px;
        margin: 40px 0px;
        padding: 0px 30px;
        user-select: none;
        line-height: 40px;
        border-radius: 4px;
        display: inline-block;
        border: 1px solid #ffffff;
      }
    }
  }
  > .part {
    padding: 80px 0px;
    > img {
      width: 1010px;
      display: block;
      margin: 0px auto;
    }
  }
}
</style>